export default "__VITE_ASSET__52ee0aea__"